// extracted by mini-css-extract-plugin
export var externalLinkCardWrapper = "external-link-card-module--external-link-card-wrapper--21af9";
export var footerButton = "external-link-card-module--footer-button--7ebf2";
export var inner = "external-link-card-module--inner--dfb97";
export var outer = "external-link-card-module--outer--1c9f1";